import React from "react";
import useTheme from "../../common/hooks/useTheme";
import { getBiomarkerValueColor } from "./designSystem/chatSemanticColors";
import type { BiomarkerSuggestionItem } from "./types";
import classes from "./Chat.module.css";

type Props = {
  item: BiomarkerSuggestionItem;
  selected: boolean;
  selectedLabel: string;
  onSelect: () => void;
};

const ChatBiomarkerSuggestionCard = ({
  item,
  selected,
  selectedLabel,
  onSelect,
}: Props) => {
  const theme = useTheme();

  return (
    <button
      type="button"
      className={`${classes.biomarkerSuggestionCard} ${
        selected ? classes.biomarkerSuggestionCardSelected : ""
      }`}
      aria-pressed={selected}
      onClick={onSelect}
    >
      <div className={classes.biomarkerSuggestionHeader}>
        <div className={classes.biomarkerSuggestionTitleBlock}>
          <span className={classes.biomarkerSuggestionName}>{item.name}</span>
          <span className={classes.biomarkerSuggestionLabel}>
            {item.secondaryLabel}
          </span>
        </div>
        <span
          className={classes.biomarkerSuggestionValue}
          style={{ color: getBiomarkerValueColor(theme, item.scoreCategory) }}
        >
          {item.latestValueLabel}
        </span>
      </div>
      <div className={classes.biomarkerSuggestionFooter}>
        <span className={classes.biomarkerSuggestionDate}>
          {item.latestDateLabel}
        </span>
        {selected && (
          <span className={classes.metricSuggestionSelectedBadge}>
            {selectedLabel}
          </span>
        )}
      </div>
    </button>
  );
};

export default ChatBiomarkerSuggestionCard;
